import { render, staticRenderFns } from "./DepositRegistration.vue?vue&type=template&id=3d4fbe65&scoped=true&"
import script from "./DepositRegistration.vue?vue&type=script&lang=js&"
export * from "./DepositRegistration.vue?vue&type=script&lang=js&"
import style0 from "./DepositRegistration.vue?vue&type=style&index=0&id=3d4fbe65&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4fbe65",
  null
  
)

export default component.exports